import React, { Component } from 'react';

import DoGoal from './doGoal';
import MeasureGoal from './measureGoal';
import ForecastGoal from './forecastGoal';

class Goal extends Component {

  update(newValue){
    this.props.updateGoalValue(this.props.goal.id, newValue);
  }
  updateMeta(newValue){
    this.props.updateGoalMeta(this.props.goal.id, newValue);
  }
  updateCustomGoalValues(newValues){
    this.props.updateCustomGoalValues(this.props.goal.id, newValues)
  }

  render(){

    const goal = this.props.goal;

    switch(goal.goalType){
      default:
      case 'do':
        return <DoGoal {...this.props} update={this.update.bind(this)} updateMeta={this.updateMeta.bind(this)} />;
      break;
      case 'measure':
        return <MeasureGoal {...this.props} update={this.update.bind(this)} updateMeta={this.updateMeta.bind(this)} updateCustomGoalValues={this.updateCustomGoalValues.bind(this)} />;
      break;
      case 'forecast':
        return <ForecastGoal {...this.props} update={this.update.bind(this)} updateMeta={this.updateMeta.bind(this)} updateCustomGoalValues={this.updateCustomGoalValues.bind(this)} />;
      break;
    }
  }
}

export default Goal;



// WEBPACK FOOTER //
// ./src/components/sprint/goalTemplates/index.js